import {
    lg,
    cloneDeep,
    util,
    isCorrectVal,
    isDate
} from 'utils';
import NProgress from 'nprogress';
import $http from '$http';

import returnOrderConfirm from '@pages/Order/Exchange/components/returnOrderConfirm/index.vue';
import exchangeConfirm from '@pages/Order/Exchange/components/exchangeConfirm/index.vue';

export default {
    components: {
        returnOrderConfirm,
        exchangeConfirm
    },
    data: function () {
        return {
            auditBtnShow: true,
            OrderStatus1: [{
                "TypeName": "全部",
                "TypeValue": "-1"
            }, {
                "TypeName": "未确认",
                "TypeValue": "6"
            }, {
                "TypeName": "已确认",
                "TypeValue": "10"
            }],
            OrderStatus2: [{
                "TypeName": "全部",
                "TypeValue": "-1"
            }, {
                "TypeName": "未确认",
                "TypeValue": "10"
            }, {
                "TypeName": "已确认",
                "TypeValue": "9"
            }],
            loading2: false,
            lists: [],
            pageIndex: 1,
            pageSize: 10,
            totalSize: '',
            sels: [], //列表选中列
            pageSizes: [10, 20, 50],
            query: this.getQuery(),
            RetrunLogistics: "",
            exchangeConfirmVisible: false,
            currentId: 0
        }
    },
    methods: {
        getQuery() {
            return cloneDeep({
                OrderCode: "",
                c_name: "",
                AgentName: "",
                OrderStatus: "",
                logistics: ""
            });
        },
        reLoadData() {
            this.pageIndex = 1;
            this.List();
        },
        //初始化加载页面
        List: function () {
            this.lists = [];
            this.loading2 = true; //拼命加载中显示
            let url = (this.$route.path == '/Order/ExchangeConfirm') ? 'api/Order/GetReturnOrderTwoByPage' : 'api/Order/GetReturnOrderOneByPage'
            
            $http.get(url, this.getParams()).then(res => {
                let {
                    StateCode,
                    StateMsg,
                    Data,
                    Cnt
                } = res.data;
                util.doResult(this, res, () => {
                    this.totalSize = Cnt;
                    this.loading2 = false; //拼命加载中隐藏
                    for (let i = 0; i < Data.length; i++) {
                        // if (Data[i].OrderStatus == 6) {
                        //     Data[i].ReturnStatusName = "待确认"
                        // } else if (Data[i].OrderStatus == 9) {
                        //     Data[i].ReturnStatusName = "已确认"
                        // }
                        Data[i].RetrunLogistics = Data[i].RetrunLogisticsName + Data[i].RetrunLogisticsCode
                    }
                    for (var i = 0; i < Data.length; i++) {
                        Data[i].AreaName = Data[i].AreaName.split("市")[0] + '市'
                        if (Data[i].AreaName == "北京北京市") {
                            Data[i].AreaName = "北京市"
                        }
                        if (Data[i].AreaName == "重庆重庆市") {
                            Data[i].AreaName = "重庆市"
                        }
                        if (Data[i].AreaName == "上海上海市") {
                            Data[i].AreaName = "上海市"
                        }
                        if (Data[i].AreaName == "天津天津市") {
                            Data[i].AreaName = "天津市"
                        }
                    }
                    this.lists = Data;

                });
            });

        },
        //通用输入参数
        getParams() {
            var para = {
                Sid: this.$store.state.sysSid,
                Session: this.$store.state.sysSession,
                pageIndex: this.pageIndex,
                pageSize: this.pageSize,
                orderBy: this.orderBy
            };
            for (let item in this.query) {
                let value = this.query[item];
                if (value != '') {
                    para[item] = value;
                }
            }
            return para;
        },
        selsChange: function (sels) {
            this.sels = sels;
        },
        //查看单条
        handleView: function (index, row) {
            util.redirect(this, '/Order/Exchange/ExchangeViewOrder?Id=' + row.OrderId, true);
        },
        //确认
        adoptHandle: function (index, row) {
            this.$refs.returnOrderConfirmView.show({
                id: row.OrderId
            });
        },
        open_exchangeConfirmDialog(index, row) {
            this.currentId = row.OrderId
            this.exchangeConfirmVisible = true
        },
        //搜索查询
        onQuerySubmit: function () {
            this.pageIndex = 1;
            this.List();
        },

        //重置
        onQueryClean: function () {
            this.query = this.getQuery();
            this.List();
        },
        //查询功能
        handleSizeChange: function(val) {
            this.pageSize = val;
            this.List();
        },
        handleCurrentChange: function(val) {
            this.pageIndex = val;
            this.List();
        }
    },
    created: function () {
        this.List();
    }

}


// WEBPACK FOOTER //
// ./src/pages/Order/Exchange/vm.js